<template>
    <basic-container>
      <el-form id="payQuery" ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
        <el-row :gutter="0">
          <el-col :span="4">
            <el-form-item label="小区名称" prop="propertyId">
              <el-select v-model="query.communityId" placeholder="请选择小区" style="width: 100%">
                <el-option
                  v-for="item in allPropertyList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="资源类型" prop="resourceType">
              <el-select v-model="query.resourceType" placeholder="全部" style="width: 100%">
                <el-option
                  v-for="item in allResourceTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="收费方式" prop="payType">
              <el-select v-model="query.payType" placeholder="全部" style="width: 100%">
                <el-option
                  v-for="item in allPayTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="时间范围" prop="rangeType">
              <el-select v-model="query.rangeType"  style="width: 100%">
                <el-option label="当天" value="0"></el-option>
                <el-option label="7日内" value="7"></el-option>
                <el-option label="30日内" value="30"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="white-space: nowrap; margin-left: 20px">
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                native-type="submit"
                @click.prevent="searchChange"
              >搜索</el-button
              >
              <el-button type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
              <template slot-scope="scope" slot="menu">
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-printer"
                  v-if="scope.row.payStatus !== '1'"
                  @click="changeStatus(scope.row)"
                >状态更新
                </el-button>
                </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update,queryResult} from "@/api/v4ward/fundpay/fundpay";
    import {mapGetters} from "vuex";
    import {getOptionNode} from "../../../api/v4ward/property/baseproperty";
    import {getDictionary} from "../../../api/common";

    export default {
        data() {
            return {
              firstEnterPageFlag:false,
                form: {},
                query: {
                  communityId: '',
                  payType: '',
                  resourceType: '',
                  rangeType: '0',
                  payFlag: '0',
                },
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                allPayTypeList: [],
                allPropertyList: [],
                allResourceTypeList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    index: false,
                    viewBtn: true,
                    selection: false,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "收费主表ID",
                                    prop: "id",
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入收费主表ID",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                                                                    {
                                    label: "地址",
                                    prop: "targetName",
                                    rules: [{
                                        required: true,
                                        message: "请输入地址",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费单号",
                                    prop: "payNo",
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入收费单号",
                                        trigger: "change"
                                    }]
                                },

                                                                                                                {
                                    label: "缴费人",
                                    prop: "payManName",
                                    rules: [{
                                        required: true,
                                        message: "请输入缴费人姓名",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "支付方式",
                                    prop: "payType",
                                    type: "select",
                                    dicUrl: "/api/blade-system/dict/dictionary?code=pay_type",
                                     props: {
                                           label: "dictValue",
                                           value: "dictKey",
                                     },
                                    rules: [{
                                        required: true,
                                        message: "请输入支付方式",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "理论金额",
                                    prop: "totalCalAmount",
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入理论总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "滞纳金额",
                                    prop: "totalDelayAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入滞纳总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "减免金额",
                                    prop: "totalDerateAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入减免总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "抵扣金额",
                                    prop: "totalAccountpayAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入账户抵扣总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "优惠金额",
                                    prop: "totalCouponAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入优惠券抵扣总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "应收金额",
                                    prop: "totalShouldAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入应收总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "实收金额",
                                    prop: "totalPayAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入实收总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收银员",
                                    prop: "cashierName",
                                    rules: [{
                                        required: true,
                                        message: "请输入收银员",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费时间",
                                    prop: "payTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入付款时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费状态",
                                    prop: "payStatus",
                                    type: "select",
                                    dicUrl: "/api/blade-system/dict/dictionary?code=fund_pay_status",
                                      props: {
                                           label: "dictValue",
                                           value: "dictKey",
                                      },
                                    rules: [{
                                        required: true,
                                        trigger: "change"
                                    }]
                                },

                                                                                                                {
                                    label: "收费来源",
                                    prop: "payCost",
                                    type: "select",
                                    dicUrl: "/api/blade-system/dict/dictionary?code=pay_cost",
                                    props: {
                                        label: "dictValue",
                                        value: "dictKey",
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请输入收费来源",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.fundpay_add, false),
                    viewBtn: this.vaildData(this.permission.fundpay_view, false),
                    delBtn: this.vaildData(this.permission.fundpay_delete, false),
                    editBtn: this.vaildData(this.permission.fundpay_edit, false),
                    changeStatusBtn: this.vaildData(this.permission.fundpay_changeStatus, true)

                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        created() {
          this.initPayTypeList();
        },
        // beforeRouteEnter (to, from, next) {
        //   console.log(to, from);
        //   if(to.query.payNo){
        //     next(vm => {
        //       // 通过 `vm` 访问组件实例
        //       console.log(vm._data.query);
        //       vm._data.query = {};
        //       vm._data.query.payNo = to.query.payNo;
        //       vm._data.query.resourceType = to.query.resourceType;
        //       console.log(vm._data.query);
        //     })
        //   }else{

        //   }
        // },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            initPropertyList() {
              getOptionNode({}).then((data) => {
                  this.allPropertyList = data.data;
                if (this.allPropertyList.length > 0) {
                  this.$set(this.query, "communityId", this.allPropertyList[0].id);
                }
              });
            },
            initPayTypeList: function () {
              getDictionary('pay_type').then((data) => {
                this.allPayTypeList = data.data;
              });
            },
            initResourceTypeList: function () {
              getDictionary('fee_resource_type').then((data) => {
                this.allResourceTypeList = data.data;
                if (this.allResourceTypeList.length > 0) {
                  this.$set(this.query, "resourceType", this.allResourceTypeList[0].dictKey);
                }
              });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            changeStatus(row){
              if (row.payStatus === 1) {
                this.$message.warning("请勿重复操作");
                return;
              }
              this.$confirm('确定要更新状态吗?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  this.loading = true;
                  queryResult({payNo: row.payNo}).then((res)=>{

                    if(res.payStatus === 1){
                      this.$message.success('该单已经缴费，请前往收费历史查询!');
                    }else{
                      this.$message.warning('该单未缴费，请稍后重试!');
                    }
                    this.onLoad();
                    this.loading = false;
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });

            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query.payType = '';
                this.query.rangeType = '0';
                this.onLoad();
            },
            searchChange(params, done) {
                //this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
          async onLoad(page) {
              if (this.allPropertyList.length == 0) {
                await getOptionNode({}).then((data) => {
                  this.allPropertyList = data.data;
                  if (this.allPropertyList.length > 0) {
                    this.$set(this.query, "communityId", this.allPropertyList[0].id);
                  }
                });
                await getDictionary('fee_resource_type').then((data) => {
                  this.allResourceTypeList = data.data;
                  if (this.allResourceTypeList.length > 0) {
                    this.$set(this.query, "resourceType", this.allResourceTypeList[0].dictKey);
                  }
                });
              }
                page = page || this.page;
                this.loading = true;
                // if(this.$route.query.payNo&&!this.firstEnterPageFlag){
                //   this.tempQuery = this.deepClone(this.query);
                //   this.query = this.$route.query;
                // }
            await getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                  
                if(this.$route.query.payNo&&!this.firstEnterPageFlag){
                  this.firstEnterPageFlag = true;
                  this.query = {};
                  // this.query.resourceType = '1';
                  // this.query.communityId = this.allResourceTypeList[0].dictKey;
                }
                  
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
